import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1a1a1a] text-white mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-4xl mb-4">Nesta</div>
          <p className="text-white/50 max-w-sm leading-relaxed">
            Considered furniture for modern living. Warm materials, quiet lines, delivered to your door.
          </p>
          <p className="text-white/40 mt-4 text-sm">hello@nest-a-furniture.com</p>
        </div>
        <div>
          <div className="text-sm uppercase tracking-luxe text-white/40 mb-5">Shop</div>
          <ul className="space-y-3 text-white/70">
            <li><Link to="/shop" className="hover:text-white">All Furniture</Link></li>
            <li><Link to="/shop" className="hover:text-white">Seating</Link></li>
            <li><Link to="/shop" className="hover:text-white">Tables</Link></li>
            <li><Link to="/shop" className="hover:text-white">Storage</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm uppercase tracking-luxe text-white/40 mb-5">Company</div>
          <ul className="space-y-3 text-white/70">
            <li>Sustainable Materials</li>
            <li>hello@nest-a-furniture.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-3 text-white/30 text-xs tracking-luxe uppercase">
        <span>© {new Date().getFullYear()} Nesta — Modern Living</span>
        <span data-testid="footer-returns-note" className="normal-case tracking-normal text-white/40 text-center">
          Returns accepted within 30 days — customers are responsible for paying the cost of collection of returns.
        </span>
      </div>
    </footer>
  );
}
